import { QueryKeys } from '@enums/queryKeys';
import { ApiRoute } from '@routes/apiRoutes';
import { httpService } from '@services/httpService';
import { useQuery } from '@tanstack/react-query';
import { PortalAnnouncementResponse } from '@models/featureFlags/portalAnnouncementModel';
import { QueryCacheConstants } from '@constants/queryCacheConstants';

export const usePortalAnnouncement = () => {
  const getPortalAnnouncement = async () => {
    return await httpService.get<PortalAnnouncementResponse>(
      ApiRoute.PortalAnnouncement
    );
  };

  return useQuery({
    queryKey: [QueryKeys.PORTAL_ANNOUNCEMENT],
    queryFn: () => getPortalAnnouncement(),
    staleTime: QueryCacheConstants.DEFAULT_STALE_TIME,
  });
};
